<template>
  <div>
    <PageTitle :route="$route" />

    <PageRowWrapper>
      <UsersForm v-if="user" :user="user" />
      <LoadingPage v-if="!user"/>
    </PageRowWrapper>

  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex'
import PageTitle from '@/components/layout/PageTitle'
import PageRowWrapper from '@/components/layout/PageRowWrapper'
import UsersForm from '@/components/settings/users/users//UsersForm'
import LoadingPage from '@/components/spinner/LoadingPage'

export default {
  name: 'UserEdit',
  components: {
    PageTitle,
    PageRowWrapper,
    UsersForm,
    LoadingPage
  },
  computed: {
    ...mapState({
      user: state => state.users.userById
    })
  },
  methods: {
    ...mapActions('users', ['fetchById'])
  },
  mounted () {
    this.fetchById(this.$route.params.id)
  }
}
</script>
